export const RENDER_FONT_OPTIONS = [
  { value: 'Inter', label: 'Inter (Modern Sans-serif)' },
  { value: 'Roboto', label: 'Roboto (Google Sans-serif)' },
  { value: 'Open Sans', label: 'Open Sans (Friendly Sans-serif)' },
  { value: 'Montserrat', label: 'Montserrat (Geometric Sans-serif)' },
  { value: 'Poppins', label: 'Poppins (Rounded Sans-serif)' },
  { value: 'Lato', label: 'Lato (Humanist Sans-serif)' },
  { value: 'Nunito', label: 'Nunito (Rounded Sans-serif)' },
  { value: 'Source Sans Pro', label: 'Source Sans Pro (Clean Sans-serif)' },
  { value: 'Raleway', label: 'Raleway (Elegant Sans-serif)' },
  { value: 'Ubuntu', label: 'Ubuntu (Modern Sans-serif)' },
  { value: 'Playfair Display', label: 'Playfair Display (Elegant Serif)' },
  { value: 'Merriweather', label: 'Merriweather (Reading Serif)' },
  { value: 'Georgia', label: 'Georgia (Classic Serif)' },
  { value: 'Times New Roman', label: 'Times New Roman (Traditional Serif)' },
  { value: 'Crimson Text', label: 'Crimson Text (Book Serif)' },
];

const serifFonts = new Set([
  'Playfair Display',
  'Merriweather',
  'Georgia',
  'Times New Roman',
  'Crimson Text',
]);

export const DEFAULT_RENDER_FONT = 'Inter';

export const resolveRenderFont = (value) => (
  RENDER_FONT_OPTIONS.some((option) => option.value === value) ? value : DEFAULT_RENDER_FONT
);

export const renderFontFamily = (value) => {
  const font = resolveRenderFont(value);
  const fallback = serifFonts.has(font)
    ? 'Georgia, "Times New Roman", serif'
    : 'Helvetica, Arial, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

  return `"${font}", ${fallback}`;
};
